import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"

function FormButton(props) {
  const { classes, label, loading, ...rest } = props
  return (
    <React.Fragment>
      <div className={classes.wrapper}>
        <Button variant="contained" disabled={loading} {...rest}>
          {label || `Submit`}
        </Button>
        {loading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    </React.Fragment>
  )
}

FormButton.propTypes = {
  classes: PropTypes.object.isRequired,
}

const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  button: {
    margin: theme.spacing.unit,
  },
  wrapper: {
    marginTop: theme.spacing.unit * 3,
    position: "relative",
    width: "100%",
    textAlign: "center",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginLeft: -12,
  },
})

export default withStyles(styles)(FormButton)
